/* prettier-ignore-start */
/* eslint-disable */
// @ts-nocheck
// noinspection JSUnusedGlobalSymbols
// Manually maintained route tree — TanStack Router file-based codegen requires Node >=20.
// Update this file whenever you add or remove route files.

import { createFileRoute, createRootRoute } from '@tanstack/react-router'

// Route imports
import { Route as rootRoute } from './routes/__root'
import { Route as LoginImport } from './routes/login'
import { Route as AuthImport } from './routes/_auth/route'
import { Route as AuthIndexImport } from './routes/_auth/index'
import { Route as AuthActivityImport } from './routes/_auth/activity'
import { Route as AuthKanbanImport } from './routes/_auth/kanban'
import { Route as AuthExportsImport } from './routes/_auth/exports'
import { Route as AuthLandlordsIndexImport } from './routes/_auth/landlords/index'
import { Route as AuthBuildingsImport } from './routes/_auth/buildings'
import { Route as AuthAdminImport } from './routes/_auth/admin/route'
import { Route as AuthAdminUsersImport } from './routes/_auth/admin/users'
import { Route as AuthAdminAssignmentsImport } from './routes/_auth/admin/assignments'
import { Route as AuthAdminManagersImport } from './routes/_auth/admin/managers'
import { Route as AuthAdminTagsImport } from './routes/_auth/admin/tags'
import { Route as AuthAdminJunkReviewImport } from './routes/_auth/admin/junk-review'
import { Route as AuthAdminImportsImport } from './routes/_auth/admin/imports'

// Create/Update Routes
const LoginRoute = LoginImport.update({
  path: '/login',
  getParentRoute: () => rootRoute,
} as never)

const AuthRoute = AuthImport.update({
  id: '/_auth',
  getParentRoute: () => rootRoute,
} as never)

const AuthIndexRoute = AuthIndexImport.update({
  path: '/',
  getParentRoute: () => AuthRoute,
} as never)

const AuthActivityRoute = AuthActivityImport.update({
  path: '/activity',
  getParentRoute: () => AuthRoute,
} as never)

const AuthKanbanRoute = AuthKanbanImport.update({
  path: '/kanban',
  getParentRoute: () => AuthRoute,
} as never)

const AuthExportsRoute = AuthExportsImport.update({
  path: '/exports',
  getParentRoute: () => AuthRoute,
} as never)

const AuthLandlordsIndexRoute = AuthLandlordsIndexImport.update({
  path: '/landlords',
  getParentRoute: () => AuthRoute,
} as never)

const AuthBuildingsRoute = AuthBuildingsImport.update({
  path: '/buildings',
  getParentRoute: () => AuthRoute,
} as never)

const AuthAdminRoute = AuthAdminImport.update({
  id: '/_auth/admin',
  path: '/admin',
  getParentRoute: () => AuthRoute,
} as never)

const AuthAdminUsersRoute = AuthAdminUsersImport.update({
  path: '/users',
  getParentRoute: () => AuthAdminRoute,
} as never)

const AuthAdminAssignmentsRoute = AuthAdminAssignmentsImport.update({
  path: '/assignments',
  getParentRoute: () => AuthAdminRoute,
} as never)

const AuthAdminManagersRoute = AuthAdminManagersImport.update({
  path: '/managers',
  getParentRoute: () => AuthAdminRoute,
} as never)

const AuthAdminTagsRoute = AuthAdminTagsImport.update({
  path: '/tags',
  getParentRoute: () => AuthAdminRoute,
} as never)

const AuthAdminJunkReviewRoute = AuthAdminJunkReviewImport.update({
  path: '/junk-review',
  getParentRoute: () => AuthAdminRoute,
} as never)

const AuthAdminImportsRoute = AuthAdminImportsImport.update({
  path: '/imports',
  getParentRoute: () => AuthAdminRoute,
} as never)

// Declare module augmentation
declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginImport
      parentRoute: typeof rootRoute
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthImport
      parentRoute: typeof rootRoute
    }
    '/_auth/': {
      id: '/_auth/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthIndexImport
      parentRoute: typeof AuthImport
    }
    '/_auth/activity': {
      id: '/_auth/activity'
      path: '/activity'
      fullPath: '/activity'
      preLoaderRoute: typeof AuthActivityImport
      parentRoute: typeof AuthImport
    }
    '/_auth/kanban': {
      id: '/_auth/kanban'
      path: '/kanban'
      fullPath: '/kanban'
      preLoaderRoute: typeof AuthKanbanImport
      parentRoute: typeof AuthImport
    }
    '/_auth/exports': {
      id: '/_auth/exports'
      path: '/exports'
      fullPath: '/exports'
      preLoaderRoute: typeof AuthExportsImport
      parentRoute: typeof AuthImport
    }
    '/_auth/landlords/': {
      id: '/_auth/landlords/'
      path: '/landlords'
      fullPath: '/landlords'
      preLoaderRoute: typeof AuthLandlordsIndexImport
      parentRoute: typeof AuthImport
    }
    '/_auth/buildings': {
      id: '/_auth/buildings'
      path: '/buildings'
      fullPath: '/buildings'
      preLoaderRoute: typeof AuthBuildingsImport
      parentRoute: typeof AuthImport
    }
    '/_auth/admin': {
      id: '/_auth/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AuthAdminImport
      parentRoute: typeof AuthImport
    }
    '/_auth/admin/users': {
      id: '/_auth/admin/users'
      path: '/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof AuthAdminUsersImport
      parentRoute: typeof AuthAdminImport
    }
    '/_auth/admin/assignments': {
      id: '/_auth/admin/assignments'
      path: '/assignments'
      fullPath: '/admin/assignments'
      preLoaderRoute: typeof AuthAdminAssignmentsImport
      parentRoute: typeof AuthAdminImport
    }
    '/_auth/admin/managers': {
      id: '/_auth/admin/managers'
      path: '/managers'
      fullPath: '/admin/managers'
      preLoaderRoute: typeof AuthAdminImport
      parentRoute: typeof AuthAdminImport
    }
    '/_auth/admin/tags': {
      id: '/_auth/admin/tags'
      path: '/tags'
      fullPath: '/admin/tags'
      preLoaderRoute: typeof AuthAdminTagsImport
      parentRoute: typeof AuthAdminImport
    }
    '/_auth/admin/junk-review': {
      id: '/_auth/admin/junk-review'
      path: '/junk-review'
      fullPath: '/admin/junk-review'
      preLoaderRoute: typeof AuthAdminJunkReviewImport
      parentRoute: typeof AuthAdminImport
    }
    '/_auth/admin/imports': {
      id: '/_auth/admin/imports'
      path: '/imports'
      fullPath: '/admin/imports'
      preLoaderRoute: typeof AuthAdminImportsImport
      parentRoute: typeof AuthAdminImport
    }
  }
}

// Build the route tree
const AuthAdminRouteWithChildren = AuthAdminRoute.addChildren([
  AuthAdminUsersRoute,
  AuthAdminAssignmentsRoute,
  AuthAdminManagersRoute,
  AuthAdminTagsRoute,
  AuthAdminJunkReviewRoute,
  AuthAdminImportsRoute,
])

const AuthRouteWithChildren = AuthRoute.addChildren([
  AuthIndexRoute,
  AuthActivityRoute,
  AuthKanbanRoute,
  AuthExportsRoute,
  AuthLandlordsIndexRoute,
  AuthBuildingsRoute,
  AuthAdminRouteWithChildren,
])

export const routeTree = rootRoute.addChildren([
  LoginRoute,
  AuthRouteWithChildren,
])

/* prettier-ignore-end */
